import { all } from 'redux-saga/effects';
import summary from 'sagas/dashboard/sales/summary';

export default function* location() {
  yield all([summary()]);
}
